<template>
  <UserGroupItemSummary
    v-bind="$attrs"
    :itemSummary="itemSummary"
  >
    <ul :class="$style.userGroupMultipleItemSummary">
      <li
        v-for="(item, index) in itemSummary.items"
        :key="index"
        :class="$style.listItem"
      >
        <div :class="$style.resource">
          <img
            :class="$style.icon"
            :src="item.iconLocation"
            svg-inline
          >
          <UserGroupItemSummary
            :itemSummary="item"
            noMargin
          >
            {{ getItemsList(item.items) }}
          </UserGroupItemSummary>
        </div>
        <!-- sub items go here -->
        <div
          v-if="item.subItems.length"
          :class="$style.listSubItemContainer"
        >
          <li :class="$style.listItem">
            <ul
              :class="$style.userGroupMultipleItemSummary"
            >
              <li
                v-for="(subItem, subIndex) in item.subItems"
                :key="subIndex"
                :class="$style.listItem"
              >
                <div :class="$style.resource">
                  <img
                    :class="$style.subItemIcon"
                    :src="subItem.iconLocation"
                    svg-inline
                  >
                  <UserGroupItemSummary
                    :itemSummary="subItem"
                    noMargin
                  >
                    {{ getItemsList(subItem.items) }}
                  </UserGroupItemSummary>
                </div>
              </li>
            </ul>
          </li>
        </div>
      <!-- end -->
      </li>
    </ul>
  </UserGroupItemSummary>
</template>
<script>
import ItemSummary from 'client/components/ItemTable/BodyComponents/UserGroupSummary/ItemSummary';
import UserGroupItemSummary from 'client/components/ItemTable/BodyComponents/UserGroupSummary/UserGroupItemSummary.vue';

export default {
  name: 'UserGroupMultipleItemsSummary',

  components: { UserGroupItemSummary },

  props: {
    itemSummary: {
      type: ItemSummary,
      required: true,
      validator: ({ items }) => items.every(item => (item instanceof ItemSummary)),
    },
  },

  methods: {
    getItemsList(itemList) {
      return itemList.join(', ');
    },
  },
};
</script>
<style module>
.userGroupMultipleItemSummary {
  list-style: none;
  padding-left: 8px;
}

.listItem {
  margin-bottom: 15px;
}

.listSubItemContainer {
  margin-left: 15px;
  margin-top: 10px;
}

.resource {
  display: grid;
  gap: 0 8px;
  grid-template: auto / auto 1fr;
}

.icon {
  height: 16px;
  margin-top: 2px;
  width: auto;
}

.subItemIcon {
  height: 16px;
  margin-top: 2px;
  width: 16px;
}
</style>
